import React, { useEffect, useState } from "react";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";


const SessionExpiredModal = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleSessionExpired = () => {
      setOpen(true);
    };

    window.addEventListener("sessionExpired", handleSessionExpired);

    return () => {
      window.removeEventListener("sessionExpired", handleSessionExpired);
    };
  }, []);

  const handleLogin = () => {
    setOpen(false);
    window.location.href = "/SignIn";
  };

  if (!open) return null;

  return ( 
      <div
                        className="modal fade show postAdd"
                        tabIndex="-1"
                        role="dialog"
                        style={{ display: "block" }}
                    >
                        <div className="modal-dialog  modal-dialog-centered " role="document">
                            <div className="modal-content d-flex justify-content-around p-2">
                                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                    <h6>You have been logged out
                                        {/* {t("modals.Are you sure you want to unfollow")}   */}
                                        </h6>
                                  </div>
                                        <p className="f-14 p-3">
                                                We noticed that you aren't active in the session, so we logged you out for your safety.
                                                  Please click on the button to log in again.
                                                </p> 
    
                                <div className="text-start mt-2 ps-3">
                                                  <button type="button" className="mainBtn" onClick={handleLogin}>
                                                      {t("SignIn.Sign in")} 
                                                  </button>
                                    {/* <button className="mainBtn1"
                                     onClick={handleLogin}>Sign In Again</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
  );
};

export default SessionExpiredModal;